export const HORARIO_PADRAO = [
  { dia: "Segunda-feira", curto: "Seg", aberto: true, blocos: ["09:00–13:00", "14:00–19:00"] },
  { dia: "Terça-feira", curto: "Ter", aberto: true, blocos: ["09:00–13:00", "14:00–19:00"] },
  { dia: "Quarta-feira", curto: "Qua", aberto: true, blocos: ["09:00–13:00", "14:00–19:00"] },
  { dia: "Quinta-feira", curto: "Qui", aberto: true, blocos: ["09:00–13:00", "14:00–19:00"] },
  { dia: "Sexta-feira", curto: "Sex", aberto: true, blocos: ["09:00–13:00", "14:00–19:00"] },
  { dia: "Sábado", curto: "Sáb", aberto: true, blocos: ["09:00–13:00"] },
  { dia: "Domingo", curto: "Dom", aberto: false, blocos: [] },
];

// JS Date.getDay(): 0=Dom, 1=Seg, ... 6=Sáb. Mapeamos para o índice no HORARIO_PADRAO (0=Seg).
const DOW_TO_INDEX = [6, 0, 1, 2, 3, 4, 5];

function toMinutes(hhmm) {
  const [h, m] = hhmm.split(":").map(Number);
  return h * 60 + m;
}

export function estaAberto(date = new Date()) {
  const idx = DOW_TO_INDEX[date.getDay()];
  const dia = HORARIO_PADRAO[idx];
  if (!dia.aberto) return { aberto: false, dia };
  const mins = date.getHours() * 60 + date.getMinutes();
  const dentro = dia.blocos.some((b) => {
    const [ini, fim] = b.split("–");
    return mins >= toMinutes(ini) && mins < toMinutes(fim);
  });
  return { aberto: dentro, dia };
}

export const CLINICAS_DETALHE = {
  "ribeira-brava": {
    slug: "ribeira-brava",
    nome: "Vet Clinic Ribeira Brava",
    nomeOficial: "Clínica Veterinária da Ribeira Brava",
    morada: "Rua de São Pedro, Edifício Belo Vale, Loja A",
    codigoPostal: "9350-139",
    cidade: "Ribeira Brava",
    telefone: "291 676 284",
    telefoneE164: "+351291676284",
    email: "ribeirabrava@vetclinic.pt",
    lat: 32.6747,
    lng: -17.0635,
    estacionamento: "Estacionamento gratuito disponível nas imediações",
    acessibilidade: "Espaço acessível a pessoas com mobilidade reduzida",
    googleRating: 4.5,
    googleReviews: 86,
    horario: HORARIO_PADRAO,
    heroImage: "/clinic-photos/exterior-edificio.jpg",
    heroAlt: "Fachada da Clínica Veterinária da Ribeira Brava",
    galeria: [
      { url: "/clinic-photos/montra-1.jpg", alt: "Montra da clínica com sinalização Aberto" },
      { url: "/clinic-photos/entrada-1.jpg", alt: "Entrada e zona de receção com sinalização Vet Clinic" },
      { url: "/clinic-photos/rececao.jpg", alt: "Balcão de receção com logótipo Vet Clinic" },
      { url: "/clinic-photos/rececao-consultorio.jpg", alt: "Sala de espera com indicação para o consultório" },
      { url: "/clinic-photos/laboratorio.jpg", alt: "Laboratório com microscópio e material de diagnóstico" },
      { url: "/clinic-photos/loja-1.jpg", alt: "Loja com alimentação especializada para cães e gatos" },
    ],
  },
  calheta: {
    slug: "calheta",
    nome: "Vet Clinic Calheta",
    nomeOficial: "Consultório Veterinário da Estrela da Calheta",
    morada: "Estrada Simão Gonçalves Câmara, nº 84, E.R. 224 – Lombo da Estrela",
    codigoPostal: "9370-139",
    cidade: "Calheta",
    telefone: "291 827 677",
    telefoneE164: "+351291827677",
    email: "calheta@vetclinic.pt",
    lat: 32.7167,
    lng: -17.1769,
    estacionamento: "Estacionamento gratuito disponível nas imediações",
    acessibilidade: "Espaço acessível a pessoas com mobilidade reduzida",
    horario: HORARIO_PADRAO,
    heroImage: "/clinic-photos/montra-2.jpg",
    heroAlt: "Fachada do Consultório Veterinário da Estrela da Calheta",
    galeria: [
      { url: "/clinic-photos/balcao.jpg", alt: "Balcão de atendimento com produtos disponíveis" },
      { url: "/clinic-photos/entrada-2.jpg", alt: "Receção com prateleiras de produtos para animais" },
      { url: "/clinic-photos/loja-suplementos.jpg", alt: "Suplementos e alimentação especializada" },
      { url: "/clinic-photos/loja-2.jpg", alt: "Acessórios, transportadoras e produtos para cão e gato" },
      { url: "/clinic-photos/loja-3.jpg", alt: "Alimentação Royal Canin para cães e gatos" },
      { url: "/clinic-photos/brand-logo.jpg", alt: "Logótipo Vet Clinic em parede de madeira" },
    ],
  },
};

export const EQUIPA_PLACEHOLDER = [
  {
    nome: "{{ A_PREENCHER_PELO_CLIENTE }}",
    funcao: "Médica Veterinária",
    bio: "Mini-bio a definir pelo cliente — formação, especialização e percurso.",
    especialidades: ["Medicina interna", "Cardiologia"],
  },
  {
    nome: "{{ A_PREENCHER_PELO_CLIENTE }}",
    funcao: "Médico Veterinário",
    bio: "Mini-bio a definir pelo cliente — formação, especialização e percurso.",
    especialidades: ["Cirurgia", "Ortopedia"],
  },
  {
    nome: "{{ A_PREENCHER_PELO_CLIENTE }}",
    funcao: "Enfermeira Veterinária",
    bio: "Mini-bio a definir pelo cliente — formação, especialização e percurso.",
    especialidades: ["Cuidados pós-operatórios", "Vacinação"],
  },
];
